import type { AxiosResponse } from "axios";

import type {
  CancelableAxiosPromise,
  S3PutSuccess,
} from "cortex/ui/src/service/base";
import { baseService } from "cortex/ui/src/service/base";

export const contentFolderService = {
  load(): CancelableAxiosPromise {
    return baseService.get("/api/content-folders");
  },

  new(name: string, items: unknown[]): CancelableAxiosPromise {
    return baseService.post("/api/content-folders", { name, items });
  },

  move(
    folderId: string | number,
    items: unknown[],
  ): Promise<AxiosResponse | S3PutSuccess> {
    return baseService.put("/api/content-folder/move", {
      items,
      folder_id: folderId,
    });
  },
};

export default contentFolderService;
